/**
 * The tithi after a given one, from its name and paksha (the cycle runs Shukla
 * Pratipada ... Purnima, Krishna Pratipada ... Amavasya; the backend's
 * TITHI_NAMES / PAKSHA order). Name + paksha rather than the numeric index, so
 * a caller never depends on which index convention a payload uses.
 */
const TITHI_NAMES = [
  "Pratipada",
  "Dwitiya",
  "Tritiya",
  "Chaturthi",
  "Panchami",
  "Shashthi",
  "Saptami",
  "Ashtami",
  "Navami",
  "Dashami",
  "Ekadashi",
  "Dwadashi",
  "Trayodashi",
  "Chaturdashi",
] as const;

function cycleIndex(name: string, paksha: string): number | null {
  if (name === "Purnima") return 14;
  if (name === "Amavasya") return 29;
  const position = (TITHI_NAMES as readonly string[]).indexOf(name);
  if (position < 0) return null;
  return paksha === "Krishna" ? position + 15 : position;
}

export function nextTithi(
  name: string,
  paksha: string
): { name: string; paksha: "Shukla" | "Krishna" } | null {
  const index = cycleIndex(name, paksha);
  if (index === null) return null;
  const next = (index + 1) % 30;
  if (next === 14) return { name: "Purnima", paksha: "Shukla" };
  if (next === 29) return { name: "Amavasya", paksha: "Krishna" };
  return { name: TITHI_NAMES[next % 15], paksha: next < 15 ? "Shukla" : "Krishna" };
}
